import React from "react";
import { FaRegCircleCheck, FaRegCircleXmark } from "react-icons/fa6";
import Badge from "../badge/badge";
import CustomTooltip from "../customTooltip/customTooltip";
import { FaRegCommentDots } from "react-icons/fa";

import "./cardTarifa.scss";

export default function CardTarifa({
    imagen = "",
    titulo = "Sin título",
    referencia = "Sin referencia",
    categoria = "Sin categoría",
    proveedores = [],
    precios = [],
    comparativas = [],
    tarifasAprobadas = [],
    comentarios = [],
    estados = [],
    medida = "",
    nombreTarifa = "",
}) {
    return (
        <div className="card-tarifa">
            <div className="card-tarifa__image">
                <img src={imagen} alt="Imagen del mueble" />
            </div>

            <div className="card-tarifa__info">
                <div className="card-tarifa__info__title">
                    <div className="card-tarifa__info__title__left">
                        {nombreTarifa && <h2>Nombre Tarifa: {nombreTarifa}</h2>}
                        <h3>
                            {titulo} ({referencia})
                        </h3>
                    </div>

                    <div className="card-tarifa__info__title__right">
                        {medida && (
                            <span>
                                <strong>Unidad de medida: </strong>
                                {medida}
                            </span>
                        )}
                        <p>{categoria}</p>
                    </div>
                </div>

                <div className="card-tarifa__info__details">
                    <div className="card-tarifa__info__details__column">
                        <h3>Proveedores</h3>
                        {proveedores.map((prov, index) => (
                            <p key={index}>{prov}</p>
                        ))}
                    </div>

                    <div className="card-tarifa__info__details__column">
                        <h3>Precio</h3>
                        {precios.map((precio, index) => (
                            <p key={index}>{precio}</p>
                        ))}
                    </div>
                    <div className="card-tarifa__info__details__column">
                        <h3>Desviación precio min.</h3>
                        {comparativas.map((comp, index) => {
                            const percentage = parseFloat(
                                comp.replace("%", "")
                            );

                            let colorClass = "";
                            if (percentage >= 0 && percentage < 5) {
                                colorClass = "percentage-green";
                            } else if (percentage >= 5 && percentage <= 20) {
                                colorClass = "percentage-orange";
                            } else if (percentage > 20) {
                                colorClass = "percentage-red";
                            }

                            return (
                                <p key={index} className={colorClass}>
                                    {comp}
                                </p>
                            );
                        })}
                    </div>

                    <div className="card-tarifa__info__details__column">
                        <h3>Tarifa aprobada</h3>
                        {tarifasAprobadas.map((aprobada, index) => (
                            <span key={index}>
                                {aprobada === 1 ? (
                                    <FaRegCircleCheck
                                        size={16}
                                        className="icon-success"
                                    />
                                ) : aprobada === 0 ? (
                                    <FaRegCircleXmark
                                        size={16}
                                        className="icon-error"
                                    />
                                ) : null}
                            </span>
                        ))}
                    </div>

                    <div className="card-tarifa__info__details__column">
                        <h3>Comentarios</h3>
                        {comentarios.map((coment, index) => (
                            <span key={index}>
                                <CustomTooltip
                                    content={coment}
                                    icon={<FaRegCommentDots size={16} />}
                                />
                            </span>
                        ))}
                    </div>

                    <div className="card-tarifa__info__details__column">
                        <h3>Estado</h3>
                        {estados.map((estado) => (
                            <div className="badge-wrapper">
                                <Badge
                                    label={estado.value}
                                    variant={estado.variant}
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
